<template>
  <v-container>
    <v-row v-bind:style="widows>600?'margin-top: 50px':'margin-top: 30px'">
      <v-col v-if="widows>600" md="3" lg="3">
        <v-img
            class="shrink mr-2"
            src="~@/assets/images/Group 183.svg"
            style="text-align: center;position: absolute; top: 58%;left: 7%;height: 250px;width: 289px; margin-right: 20% !important;"
        >
          <img src="~@/assets/images/c.jpg">
        </v-img>
      </v-col>
      <v-col md="5" lg="5" sm="12" cols="12"
             v-bind:style="widows>600?'margin-left: 50px':'text-aline:center;width: 90%;'">
        <div class="telegraficoFont" v-if="widows>600" style="font-size: 20px; width: 100%; text-align: center">
          A D D<span class="telegraficoFont" style="margin-left: 20px">Y O U R</span><span
            style="margin-left: 20px" class="telegraficoFont">I N F O R M A T I O N</span>
        </div>
        <div class="telegraficoFont" v-if="widows<600" style="font-size: 15px; width: 100%; text-align: center">
          ADD YOUR INFORMATION
        </div>
        <div v-bind:style="widows>600?'margin-top: 60px':'margin-top: 20px'">
          <div>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
              <v-text-field
                  v-model="name"
                  ref="name"
                  :rules="nameRules"
                  label="Full Name"
                  class="fieldH"
                  outlined
              ></v-text-field>
              <v-text-field
                  v-model="email"
                  ref="email"
                  :rules="emailRules"
                  label="Email"
                  class="fieldH"
                  outlined
              ></v-text-field>
              <v-text-field
                  v-model="phoneNumber"
                  :ref="phoneNumber"
                  label="Phone Number"
                  class="fieldH"
                  :rules="phoneRules"
                  outlined
              ></v-text-field>
            </v-form>
          </div>

        </div>
        <div style="text-align: center">
          this order will take tow weeks
        </div>
        <div style="text-align: center">
          <v-btn :disabled="!valid" height="30px" width="120"
                 @click="validate"
                 v-bind:style="valid?'background-color: #FFFFFF!important;color: black!important':'background-color: gray!important;color: black!important'"
                 style="margin-top:30px;border-radius:5px;">
            Confirm
          </v-btn>
        </div>
      </v-col>

      <v-col md="4" lg="4" sm="12" cols="12" v-if="widows>600">
        <v-img
            class="shrink mr-2"
            src="~@/assets/images/Group183.svg"
            style="    text-align: center; position: absolute;top: -37px; left: 74%;margin-top:30px;height: 250px;width: 289px; margin-right: 20% !important;"
        >
          <img style="margin-top: 40px;" src="~@/assets/images/c.jpg">
        </v-img>
      </v-col>
    </v-row>
    <v-snackbar
        v-model="snackbar"
    >
      Your Order Has been submitted
      <template v-slot:action="{ attrs }">
        <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>

</template>

<script>

import router from "@/router";
import {saveOrder} from "@/shared/orderService";

export default {
  name: "confirmPurchase",
  data() {

    return {
      router,
      snackbar: false,
      valid: false,
      widows: window.innerWidth,
      name: null,
      nameRules: [
        v => !!v || 'Name is required'
      ],
      email: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      phoneNumber: null,
      phoneRules: [
        v => !!v || 'phone is required',
        v => (v && v.length === 10) || 'phone must be 10 number'
      ]
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        const id = this.$route.query.id;
        const data = {
          product_id: id,
          full_name: this.name,
          email: this.email,
          phone_number: this.phoneNumber
        };
        saveOrder(data).then(() => {
          this.snackbar = true;
          this.$refs.form.reset();
        });

      }
    },
  }
}
</script>

<style scoped>
::v-deep .theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: whitesmoke;
  border-radius: 10px;
}

.fieldH {
  height: 80px !important;
}

::v-deep .v-label {
  font-size: 12px;
}

</style>
